import { SET_SEARCH_FILTER_ACTION } from "./constants";

export const 
setSearchFilterAction =
  (searchFilterType, searchFilter, searchPage = "") =>
  (dispatch) => {
    dispatch({
      type: SET_SEARCH_FILTER_ACTION[searchFilterType],
      searchFilter: searchFilter,
      searchPage: searchPage,
    });
  };
